import(/* webpackMode: "eager" */ "/opt/build/repo/src/app/settings/page.jsx")